import { CruiseSrc, ILocale } from 'types';
import { EVENT_TYPE, PROD_CATEGORY } from '../constants';
import { getInteraction, getItineraryCardInfo, getUrgencyParam } from '../utils';

interface GenreicIDetailsProps {
	cruise: CruiseSrc;
	cruiseIndex?: number;
	resultsLength?: number;
	locale: ILocale;
	action: string;
	urgencyText?: string;
}

export const getIDetailsGeneric = ({ cruise, cruiseIndex, resultsLength, locale, action, urgencyText }: GenreicIDetailsProps) => {
	const resultsCount = cruise.resultsLength ?? resultsLength;
	const cardPosition = cruise.searchIndex ?? cruiseIndex;

	return {
		cardPosition: [cardPosition],
		country: locale.country,
		csDepartureDate: [cruise.lowestPriceSailing?.startDate],
		currency: locale.currency,
		eventType: EVENT_TYPE.interaction,
		groupID: [cruise.id],
		interaction: getInteraction(cardPosition, resultsCount, cruise.masterSailing, action),
		itineraryCardInfo: getItineraryCardInfo(cruise.id, cruise.masterSailing, cruise.lowestPriceSailing),
		language: locale.language,
		prodCategory: [PROD_CATEGORY.booking],
		prodCost: [Math.round(cruise.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value)],
		prodSku: [cruise.masterSailing?.itinerary?.code],
		urgencyText: getUrgencyParam(urgencyText),
	};
};
